export var TrafficSource;
(function (TrafficSource) {
    TrafficSource["Mixed"] = "MIXED";
    TrafficSource["Bing"] = "BING";
    TrafficSource["Email"] = "EMAIL";
    TrafficSource["FB"] = "FB";
    TrafficSource["GA"] = "GA";
    TrafficSource["Native"] = "NATIVE";
    TrafficSource["Pops"] = "POPS";
    TrafficSource["Push"] = "PUSH";
    TrafficSource["SEO"] = "SEO";
    TrafficSource["SMS"] = "SMS";
    TrafficSource["YouTube"] = "YOUTUBE";
    TrafficSource["Twitter"] = "TWITTER";
    TrafficSource["Tiktok"] = "TIKTOK";
})(TrafficSource || (TrafficSource = {}));
export const TrafficSourceMap = new Map([
    [TrafficSource.Mixed, 'Mixed'],
    [TrafficSource.Bing, 'Bing'],
    [TrafficSource.Email, 'Email'],
    [TrafficSource.FB, 'FB'],
    [TrafficSource.GA, 'GA'],
    [TrafficSource.Native, 'Native'],
    [TrafficSource.Pops, 'Pops'],
    [TrafficSource.Push, 'Push'],
    [TrafficSource.SEO, 'SEO'],
    [TrafficSource.SMS, 'SMS'],
    [TrafficSource.YouTube, 'YouTube'],
    [TrafficSource.Twitter, 'Twitter'],
    [TrafficSource.Tiktok, 'Tiktok'],
]);
